import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import { studioCopy } from '../../../../utils/contentCopy';
import StudioCtaRow from '../../StudioCtaRow';
import SpotlightFrame, { type SpotlightInjectedProps, type SpotlightLayoutProps } from './SpotlightFrame';

const SpotlightCtaContent: React.FC<SpotlightInjectedProps & { content: any }> = ({
  content,
  tokens,
  isStory,
  locale,
  qrCodeUrl
}) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const bullets = Array.isArray(content.bullets) ? content.bullets : [];

  return (
    <div>
      {content.kicker ? (
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
            padding: isStory ? '7px 11px' : '6px 9px',
            color: t.onAccent,
            background: t.accent,
            fontSize: typeSize(isStory ? 10 : 8.5),
            fontWeight: 900,
            letterSpacing: 1.4,
            textTransform: 'uppercase',
            transform: 'rotate(-2deg)'
          }}
        >
          <span>↗</span>
          {content.kicker}
        </div>
      ) : null}
      <h2
        style={{
          maxWidth: 310,
          margin: content.kicker ? (isStory ? '24px 0 0' : '18px 0 0') : 0,
          color: t.ink,
          fontSize: typeSize(isStory ? 39 : 31),
          fontWeight: 950,
          letterSpacing: '-1.5px',
          lineHeight: 1.14
        }}
      >
        {content.title}
      </h2>
      {content.subtitle ? (
        <p
          style={{
            maxWidth: 295,
            margin: isStory ? '18px 0 0' : '14px 0 0',
            color: t.muted,
            fontSize: typeSize(isStory ? 13.5 : 11.5),
            fontWeight: 600,
            lineHeight: 1.68
          }}
        >
          {content.subtitle}
        </p>
      ) : null}

      {bullets.length ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: isStory ? 12 : 10, marginTop: isStory ? 24 : 20 }}>
          {bullets.map((bullet: string, index: number) => (
            <div
              key={`${index}-${bullet}`}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 9,
                color: t.ink,
                fontSize: typeSize(isStory ? 11.5 : 9.8),
                fontWeight: 700
              }}
            >
              <span style={{ width: 12, flexShrink: 0, color: t.accent, fontWeight: 950, lineHeight: 1.6 }}>✓</span>
              <span style={{ flex: 1, minWidth: 0, lineHeight: 1.6 }}>{bullet}</span>
            </div>
          ))}
        </div>
      ) : null}

      <StudioCtaRow qrCodeUrl={qrCodeUrl} isStory={isStory} style={{ marginTop: isStory ? 24 : 18 }}>
        <div
          style={{
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            gap: isStory ? 12 : 10,
            width: 'fit-content',
            maxWidth: '100%',
            boxSizing: 'border-box',
            padding: isStory ? '16px 17px' : '13px 14px',
            border: `2px solid ${t.accent}`,
            color: t.onAccent,
            background: t.accent,
            fontSize: typeSize(isStory ? 13.5 : 11.5),
            fontWeight: 900,
            letterSpacing: 0.25,
            boxShadow: `7px 7px 0 rgba(255,255,255,0.12)`
          }}
        >
          <span style={{ minWidth: 0, lineHeight: 1.25, overflowWrap: 'anywhere' }}>
            {content.actionLabel || studioCopy.learnMore(locale)}
          </span>
          <span style={{ flexShrink: 0, fontSize: typeSize(isStory ? 22 : 18), lineHeight: 0.8 }}>→</span>
        </div>
      </StudioCtaRow>
    </div>
  );
};

const SpotlightCtaLayout: React.FC<SpotlightLayoutProps> = props => (
  <SpotlightFrame {...props}>
    <SpotlightCtaContent content={props.content || {}} />
  </SpotlightFrame>
);

export default SpotlightCtaLayout;
